import type { AccountRole } from '~/types'
import { heatProtectionRoles } from '~/authorization'
import { canAccess } from '~/authorization/permissions'

export default defineNuxtRouteMiddleware((to) => {
  if (to.path.startsWith('/auth')) {
    return
  }

  const { role } = useAuthorization()

  if (to.path === '/' && role.value !== 'admin' && heatProtectionRoles.includes(role.value as AccountRole)) {
    return navigateTo('/heat-protection/contacts')
  }

  if (!canAccess(role.value, to.path)) {
    return navigateTo('/')
  }
})
